import { EvaluationDataType, MatchTypeVariation } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { Ok, Result } from 'ts-res';
import { KameleoonError } from 'src/kameleoonError';

export class TargetExperimentCondition implements ICondition {
  private variationMatchType?: MatchTypeVariation | null;
  private variationId: number;
  private experimentId: number;

  constructor({
    variationMatchType,
    variation,
    experiment,
  }: ConditionDataType) {
    this.variationMatchType = variationMatchType;
    this.variationId = variation || -1;
    this.experimentId = experiment || -1;
  }

  public evaluate(data: EvaluationDataType): Result<boolean, KameleoonError> {
    return Ok(this.checkCondition(data));
  }

  private checkCondition(data: EvaluationDataType): boolean {
    const variation = data.variationData[this.experimentId];
    if (!variation) {
      return false;
    }

    switch (this.variationMatchType) {
      case MatchTypeVariation.ANY:
        return true;
      case MatchTypeVariation.EXACT:
        return variation.variationId === this.variationId;
      default:
        return false;
    }
  }
}
